import React, { useMemo, useState } from "react";
import Button from "@mui/material/Button";
import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux"; 
import {
  NameField,
  SurnameField,
  IDType,
  OneColumn,
  IDTypeSelectComponent,
  MenuItemsForDropDown,
  TrustNumberField,
  IDNumberComponent,
  PassportComponent,
  CompanyRegNoField
} from "@soqs/common"; 
import { Form, FormSpy } from "react-final-form";
import {
  updateFormState,
  searchResultsTRN,
  sendCommunicationAsync,
  formState,
  cancelVerification,
  dropdownoptions,
  dropdownsloading,
  isLoading,
} from "../../features/trnAppSlice";
import EmailAddressTRN from "../Helpers/UserComponents/EmailComponent";
import PhoneFieldComponent from "../Helpers/UserComponents/PhoneFieldComponent";
import QuarterColumn from "../Helpers/quartercolumn";
import ThreeQuarterColumn from "../Helpers/threequartercolumn";
import CheckboxComponent from "../Helpers/UserComponents/CheckboxComponent";
import { PAGES } from "../../App";
import { config } from "../../config";

export default function SendMyTRN() {
  const dispatch = useDispatch();
  const reduxFormState = useSelector(formState);
  const resultsTRN = useSelector(searchResultsTRN);
  const dropdownopts = useSelector(dropdownoptions);
  const dropdownoptsloading = useSelector(dropdownsloading);
  const loading = useSelector(isLoading);

  //Both Mobile and Email cannot be empty
  const [ setMobileNumberTRN] = useState();

  const handleChangeMobile = (event) => {
    setMobileNumberTRN(event.target.values);
  };
  const [ setEmailAddressTRN] = useState();

  const handleChangeEmail = (event) => {
    setEmailAddressTRN(event.target.values);
  };

  //Remove a trailing period if it exists
  const cleanedEmail = resultsTRN.trnEmailAddress.endsWith(".")
    ? resultsTRN.trnEmailAddress.slice(0, -1)
    : resultsTRN.trnEmailAddress;
  const cleanedMobile = resultsTRN.trnMobileNumber.endsWith(".")
    ? resultsTRN.trnMobileNumber.slice(0, -1)
    : resultsTRN.trnMobileNumber;

  const prefilledState = useMemo(
    () => reduxFormState.values,
    []
  );

  // Internal State
  const handleSubmit = async () => {
    await dispatch(sendCommunicationAsync());
  };

  return (
    <>
      <Grid size={{ xs: 12 }}>
        <Form onSubmit={handleSubmit} initialValues={prefilledState}>
          {({ handleSubmit, values }) => (
            <>
              <FormSpy
                render
                onChange={(state) => {
                  dispatch(updateFormState(state));
                }}
              />
              <Card style={{ marginTop: "2vh", color: "#00558b" }}>
                <CardHeader title="My Identification Details" />
                <CardContent>
                  <Grid container columnSpacing={1.5} rowSpacing={0.5}>
                    <OneColumn>
                      <IDTypeSelectComponent
                        name="IDType"
                        options={MenuItemsForDropDown(
                          "idtype",
                          dropdownopts,
                          true
                        )}
                        optionsloading={dropdownoptsloading}
                        disabled={true}
                      />
                    </OneColumn>
                    <OneColumn>
                      {values?.IDType == IDType.RSA_Id ? (
                        <IDNumberComponent disabled={true} name="IDNumber" />
                      ) : values?.IDType == IDType.Passport ? (
                        <PassportComponent disabled={true} name="IDNumber" />
                      ) : values?.IDType == IDType.CompanyRegistrationNumber ? (
                        <CompanyRegNoField disabled={true} name="IDNumber" />
                      ) : values?.IDType == IDType.TrustNumber ? (
                        <TrustNumberField disabled={true} name="IDNumber" />
                      ) : (
                        <IDNumberComponent disabled={true} name="IDNumber" />
                      )}
                    </OneColumn>
                    <OneColumn>
                      <NameField
                        disabled={true}
                        aria-label="Name"
                        name="Name"
                      />
                    </OneColumn>
                    <OneColumn>
                      <SurnameField
                        disabled={true}
                        aria-label="Surname"
                        name="Surname"
                      />
                    </OneColumn>
                    {/* <Popup trigger={values?.useMobileNumberTRN === false && values?.useEmailAddressTRN === false}>
                      <h1>Please tick a box!</h1> 
                      <h4>
                        Please select at least one method of communication by ticking a box
                      </h4>
                    </Popup>
                    <Popup trigger={values?.mobile === null && values?.email === null} >
                      <h1>Cellphone or Email is required</h1>
                      <h3>Please provide Cellphone number or Email address to continue</h3>
                    </Popup> */}
                  </Grid>
                </CardContent>
                <CardHeader title="Send My Tax Reference Number To" />
                <CardContent>
                  <Grid container columnSpacing={1.5} rowSpacing={0.5}>
                    <ThreeQuarterColumn>
                      {/* {kiosktoken ? (
                        <PhoneFieldComponent
                          disabled={false}
                          initialValue={cleanedMobile}
                          aria-label="Send to mobile number"
                          useRef="mobileNumberTRN"
                          onChange={handleChangeMobile}
                          name="useNewMobile"
                        />
                      ) : ( */}
                      <PhoneFieldComponent
                        disabled={true}
                        initialValue={cleanedMobile}
                        aria-label="Send to mobile number"
                        useRef="mobileNumberTRN"
                        onChange={handleChangeMobile}
                      />
                      {/* )} */}
                    </ThreeQuarterColumn>
                    <QuarterColumn>
                      <CheckboxComponent
                        defaultChecked={values?.useNewMobile !== ""}
                        size="large"
                        name="useMobileNumberTRN"
                        initialValue={values?.useNewMobile !== ""}
                        disabled={values?.useNewMobile === ""}
                      />
                    </QuarterColumn>
                    <ThreeQuarterColumn>
                      {/* {kiosktoken ? (
                        <EmailAddressTRN
                          disabled={false}
                          initialValue={cleanedEmail}
                          aria-label="Send to email"
                          useRef="emailAddressTRN"
                          onChange={handleChangeEmail}
                          name="useNewEmail"
                        />
                      ) : ( */}
                      <EmailAddressTRN
                        disabled={true}
                        initialValue={cleanedEmail}
                        aria-label="Send to email"
                        useRef="emailAddressTRN"
                        onChange={handleChangeEmail}
                      />
                      {/* )} */}
                    </ThreeQuarterColumn>
                    <QuarterColumn>
                      <CheckboxComponent
                        defaultChecked={values?.useNewEmail !== ""}
                        size="large"
                        name="useEmailAddressTRN"
                        initialValue={values?.useNewEmail !== ""}
                        disabled={values?.useNewEmail === ""}
                      />
                    </QuarterColumn>
                  </Grid>
                </CardContent>
              </Card>

              <Card>
                <CardContent>
                  <Grid container columnSpacing={1.5} rowSpacing={0.5}>
                    <Grid size={{ xs: 12 }}>
                      <Grid container justifyContent="space-between">
                        <Grid>
                          <Button
                            type="button"
                            variant="outlined"
                            onClick={() =>
                              dispatch(
                                cancelVerification({
                                  targetPage: PAGES.WhatsMyTaxNumberForm,
                                })
                              )
                            }
                          >
                            Cancel
                          </Button>
                        </Grid>
                        <Grid>
                          <Button
                            //align="right"
                            loading={loading}
                            type="submit"
                            variant="contained"
                            onClick={(e) => {
                              const ok = !!(
                                values?.useMobileNumberTRN ||
                                values?.useEmailAddressTRN
                              );
                              if (!ok) return; // block if neither option selected
                              handleSubmit(); // otherwise submit
                            }}
                          >
                            Confirm
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              {["development"].includes(config.ENVIRONMENT) ? (
                <pre>{JSON.stringify(values, null, 2)}</pre>
              ) : (
                <></>
              )}
            </>
          )}
        </Form>
      </Grid>
    </>
  );
}
